import { CSSProperties } from "@material-ui/core/styles/withStyles";

import { Text } from "@/features/common/components/tailwind/Text";
import { View } from "@/features/common/components/tailwind/View";

interface EmptyTextProps {
  message: string;
  textStyle?: CSSProperties;
}

export const EmptyText: React.FC<EmptyTextProps> = (props) => {
  const { message, textStyle = {} } = props;

  return (
    <View className="w-full flex justify-center ">
      <Text size="normal" style={{ ...textStyle }}>
        {message}
      </Text>
    </View>
  );
};
